(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rl-product-details"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = text => (text || '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '');
  function initProductDetails() {
    const root = document.querySelector('main [data-rl-product-details]');
    if (!root) return;
    const seen = new Set([normalize(root.textContent)]);
    const whyContent = root.querySelector('[data-rl-detail="why"] .rl-product-details__content');
    const descriptionText = normalize(whyContent.textContent);
    seen.add(descriptionText);
    function populate() {
      let foundSource = false;
      document.querySelectorAll('.easytabs-container .easytabs-content-item').forEach(item => {
        const title = item.querySelector('.easytabs-header-text');
        const source = item.querySelector('.easytabs-content-holder');
        if (!title || !source) return;
        foundSource = true;
        const text = normalize(source.textContent);
        if (!text || seen.has(text)) return;
        const label = title.textContent.trim();
        const name = normalize(label);
        if (/whatyoullfeel|productdescription|^description$/.test(name) && descriptionText && (text.includes(descriptionText) || descriptionText.includes(text))) { seen.add(text); return; }
        let key = /ingredient|composition/.test(name) ? 'ingredients' : /howtouse|directions|careinstructions/.test(name) ? 'use' : 'why';
        if (/staringredient/.test(name)) key = 'why';
        const detail = root.querySelector('[data-rl-detail="' + key + '"]');
        const target = detail.querySelector('.rl-product-details__content');
        const clone = source.cloneNode(true);
        clone.querySelectorAll('script,style').forEach(node => node.remove());
        clone.querySelectorAll('[style],[id],[role],[aria-hidden]').forEach(node => {
          ['style','id','role','aria-hidden'].forEach(attr => node.removeAttribute(attr));
        });
        clone.querySelectorAll('p').forEach(node => {
          if (!normalize(node.textContent) && !node.querySelector('img,video,iframe')) node.remove();
        });
        const first = clone.firstElementChild;
        if (first && normalize(first.textContent) === name) first.remove();
        const group = document.createElement('div');
        if (key === 'why' && descriptionText) {
          group.className = 'rl-product-details__extra';
          const heading = document.createElement('h3');
          heading.textContent = label;
          group.append(heading);
        }
        group.append(...clone.childNodes);
        target.append(group);
        detail.hidden = false;
        seen.add(text);
      });
      if (foundSource) document.body.classList.add('rl-product-details-ready');
    }
    populate();
    if (!document.querySelector('.easytabs-container')) {
      const observer = new MutationObserver(() => {
        if (document.querySelector('.easytabs-container')) { populate(); observer.disconnect(); }
      });
      observer.observe(document.querySelector('main'), {childList:true, subtree:true});
      setTimeout(() => observer.disconnect(), 10000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductDetails, {once:true});
  else initProductDetails();
  document.addEventListener('shopify:section:load', initProductDetails);
})();
  } catch(e) { console.error(e); }
})();

})();
